export const DEFAULT_TRANSIFEX_LOCALE = 'en';
export const DEFAULT_LOCALE = 'en-GB';
